import { render, staticRenderFns } from "./migr_list.vue?vue&type=template&id=1a0941a4&scoped=true&"
import script from "./migr_list.vue?vue&type=script&lang=js&"
export * from "./migr_list.vue?vue&type=script&lang=js&"
import style0 from "./migr_list.vue?vue&type=style&index=0&id=1a0941a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0941a4",
  null
  
)

export default component.exports